import React from "react";
import UAParser from "ua-parser-js";

const ua = new UAParser(navigator.userAgent);
const browser = ua.getBrowser();
const name = browser.name ?? "Unknown";
const version = browser.version ?? "Unknown";
const cname = name.toLowerCase();
const source = `https://cdnjs.cloudflare.com/ajax/libs/browser-logos/72.0.0/${cname}/${cname}.svg`;

export const BrowserInfo = () => {
    return (
        <div className="flex items-center">
            {name} {version}
            <img src={source} alt={name} className="ml-1 inline-block h-4 w-4" />
        </div>
    );
};
